import React, { useState } from "react"
import DropDown from "./DropDown"
import { MenuButton, MenuItem } from "@headlessui/react"
import { writeToCookie } from "../../utils/Helpers"
import { COOKIE_KEYS } from "../../utils/Constants"

export const PageSizeSelector = ({ pageSize, setPageSize, actionHandler }) => {
    const onPageSizeChangeHandler = (desiredPageSize: any) => {
        if (desiredPageSize === pageSize) return
        setPageSize(desiredPageSize)

        writeToCookie(COOKIE_KEYS.PAGE_COUNT, desiredPageSize);
        actionHandler(desiredPageSize)
    }

    return (
        <React.Fragment>
            <div className="w-36 md:block hidden">
                <DropDown
                    type='custom'
                    button={
                        <MenuButton className="w-auto min-w-24 flex align-middle items-center gap-x-1 px-2.5 py-1 text-sm text-slate-600 dark:text-slate-400 border border-slate-300 dark:border-slate-400 rounded-md bg-white dark:bg-slate-900 hover:bg-white dark:hover:bg-slate-900/30 focus:bg-white dark:focus:bg-slate-900/50 focus:outline-none focus:ring-0 focus:ring-slate-500/50 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 ease-in-out">
                            <span className="flex-grow text-start">
                                {pageSize} per page
                            </span>

                            <div className="flex-none w-5 flex items-center justify-center">
                                <span className="fa-regular fa-chevron-down block"></span>
                            </div>
                        </MenuButton>
                    }
                    items={
                        <div className="w-32 text-slate-700 dark:text-slate-400">
                            {
                                [25, 50, 100].map((pageSet) => (
                                    <MenuItem key={`pgn-quant-bit-${pageSet}`}>
                                        <button type="button" className="w-full gap-x-2 rounded-md px-3 py-2 text-sm data-[focus]:bg-slate-200 dark:data-[focus]:bg-slate-700 data-[focus]:text-slate-900 dark:data-[focus]:text-slate-300" onClick={() => onPageSizeChangeHandler(Number(pageSet))}>
                                            <div className="w-full flex items-center align-middle cursor-pointer gap-x-2">
                                                <div className="flex-1 flex flex-row-reverse">
                                                    <span className="text-end">{pageSet}</span>
                                                </div>

                                                <div className="flex-none">
                                                    <span className="text-start">per page</span>
                                                </div>
                                            </div>
                                        </button>
                                    </MenuItem>
                                ))
                            }
                        </div>
                    }
                />
            </div>
        </React.Fragment>
    )
}